

























import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import delNonNumCode from '@/utils/delNonNumCode'
@Component
export default class AppPhoneInput extends Vue {
  @Prop({ type: String }) readonly value!: string
  @Prop(String) readonly label!: string
  @Prop({ type: String }) readonly placeholder!: string
  @Prop({ type: Boolean, default: false }) readonly required!: boolean
  @Prop({ type: [Number, String], default: '289' }) readonly width!: number | string
  @Prop({ type: [Number, String], default: 36 }) readonly height!: number | string
  @Prop({ type: String, default: '' }) readonly className!: string
  @Prop({ type: Boolean, default: false }) readonly isShowExt!: boolean
  @Prop({ type: [Number, String] }) readonly extVal!: number | string
  @Prop({ type: String }) readonly countryCodeVal!: number | string

  phoneNumber = ''
  nationalNumber = ''
  ext = ''
  countryCode = ''
  countryCallingCode = ''
  showError = false
  mounted () {
    const valList = this.value ? this.value.split(',') : []
    this.phoneNumber = valList[1] ? valList[1] : ''
    this.nationalNumber = valList[1] ? valList[1] : ''
    this.countryCode = valList[0] ? valList[0] : 'US'
    this.ext = valList[2] ? valList[2] : ''
    this.countryCallingCode = valList[3] ? valList[3] : ''
  }
  @Emit('search')
  searchHandler () {}

  @Emit('input')
  valueChangedHandler (val: any, type?: string) {
    if (!type) {
      this.phoneNumber = val.phoneNumber
      this.countryCode = val.countryCode
      this.nationalNumber = val.nationalNumber || ''
      this.countryCallingCode = val.countryCallingCode || ''
    }
    const spliceVal = this.countryCode + ',' + (this.nationalNumber || '') + ',' + delNonNumCode(this.ext) + ',' + this.countryCallingCode
    return spliceVal
  }

  extChangedHandler (val: string) {
    this.ext = val
    this.valueChangedHandler(val, 'ext')
  }

  phoneNumberBlur () {
    if (this.required) {
      if (!this.phoneNumber) {
        this.showError = true
      } else {
        this.showError = false
      }
    }
  }
}
